import { SparkJob } from '../types/sparkTypes';

export interface CreativeScopeContext {
  creativeFqn: string;
  iterationFqns: string[];
}

export function isJobRelevantToCreative(job: SparkJob, scope: CreativeScopeContext): boolean {
  const ownerFqns = job._owner_fqns ?? [];
  const args = job._action_args?.action_args ?? {};
  const inputCreativeFqns = [
    ...(Array.isArray(args.input_creative_fqns) ? args.input_creative_fqns : []),
    ...(args.input_creative_fqn ? [args.input_creative_fqn] : []),
  ];
  const inputIterationFqns = [
    ...(Array.isArray(args.input_iteration_fqns) ? args.input_iteration_fqns : []),
    ...(args.input_iteration_fqn ? [args.input_iteration_fqn] : []),
  ];

  return (
    ownerFqns.includes(scope.creativeFqn) ||
    ownerFqns.some((fqn) => scope.iterationFqns.includes(fqn)) ||
    inputCreativeFqns.includes(scope.creativeFqn) ||
    inputIterationFqns.some((fqn: string) => scope.iterationFqns.includes(fqn))
  );
}
